import { useColorScheme } from '@mui/material';
import { money, moneyCompact, qty, type FormatSettings } from '../../../lib/format';

/**
 * Charts for reports. Categorical colours follow a fixed, colour-blind-checked order (never
 * cycled); single-series charts use the shop's brand colour.
 */
const SERIES_LIGHT = [
  '#2a78d6',
  '#eb6834',
  '#1baf7a',
  '#eda100',
  '#e87ba4',
  '#008300',
  '#6250d6',
  '#e34948',
];
const SERIES_DARK = [
  '#3987e5',
  '#d95926',
  '#199e70',
  '#c98500',
  '#d55181',
  '#008300',
  '#9085e9',
  '#e66767',
];
export const OTHER_COLOR = { light: '#98A2B3', dark: '#667085' };

export function useSeriesColors(): { colors: string[]; other: string } {
  const { mode, systemMode } = useColorScheme();
  const dark = (mode === 'system' ? systemMode : mode) === 'dark';
  return {
    colors: dark ? SERIES_DARK : SERIES_LIGHT,
    other: dark ? OTHER_COLOR.dark : OTHER_COLOR.light,
  };
}

export type ValueKind = 'money' | 'count' | 'percent';

/** Formats a chart value: compact for axes, full for tooltips. */
export function formatValue(
  v: number | null,
  kind: ValueKind,
  format: FormatSettings,
  compact = false,
): string {
  const n = v ?? 0;
  if (kind === 'money') return compact ? moneyCompact(n, format) : money(n, format);
  if (kind === 'percent') return `${n.toFixed(compact ? 0 : 1)}%`;
  return qty(n, format);
}
